export enum WidgetDataResponseStatus {
    Unknown = 0,
    Ok = 1,
    Error = 2,
    Warning = 3,
    Message = 4,
}
